import React from 'react';
import './ProductDetailModal.css';

const formatPrice = (value) => {
  const num = typeof value === 'number' ? value : Number(value);
  if (!Number.isFinite(num)) return '0,00';
  return num
    .toFixed(2)
    .replace('.', ',')
    .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
};

const ProductDetailModal = ({ product, onClose }) => {
  if (!product) return null;

  const images = Array.isArray(product.images) ? product.images : [];
  const categoryText = product.category
    || (Array.isArray(product.categories) ? product.categories.join(', ') : '')
    || '—';

  const handleOverlayClick = () => {
    if (typeof onClose === 'function') onClose();
  };

  return (
    <div
      className="modal-overlay-container"
      onClick={handleOverlayClick}
      role="presentation"
    >
      <div
        className="modal-content-container product-detail-modal"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label={product.model || 'Detalle del producto'}
      >
        <h3>{product.model}</h3>
        {images.map((image, index) => (
          <img
            key={index}
            src={image}
            alt={product.model || `Producto ${index + 1}`}
            className="product-detail-image"
          />
        ))}
        <p><strong>Precio:</strong> ${formatPrice(product.price)}</p>
        <p><strong>Categoría:</strong> {categoryText}</p>
        {product.description && (
          <p><strong>Descripción:</strong> {product.description}</p>
        )}
        <button type="button" onClick={onClose} className="close-button">
          Cerrar
        </button>
      </div>
    </div>
  );
};

export default ProductDetailModal;
